import React, { useState } from 'react'
import LocationSearchBox from './LocationSearchBox'
import GoogleMap from './GoogleMap'
import { Link } from 'react-router-dom'
import { noLocationRoute } from '../../routes/routes'
import { Action } from '@foodsby/nutrient'

const LocationsList = ({ locations, onToggleOpen, isOpenId, goToLocation }) => (
  <div className="searchLocationsList" id="searchLocationsList">
    {locations.map((location, i) => {
      const selected = isOpenId === location.deliveryLocationId

      return (
        <div
          className="row searchLocation"
          data-selected={selected}
          id={`searchLocation-${location.deliveryLocationId}`}
          key={i}
          onClick={e => goToLocation(location.deliveryLocationId)}
          onMouseOut={() => onToggleOpen(location.deliveryLocationId)}
          onMouseOver={() => onToggleOpen(location.deliveryLocationId)}
        >
          <div className="col-xs start-xs">
            <div className="searchLocationName">{location.locationName}</div>

            {location.deliveryLine1 && <>{location.deliveryLine1}</>}
            {location.lastLine && (
              <>
                <br />
                {location.lastLine}
                <br />
              </>
            )}
            <br />
            <div className="searchLocationInstructions">
              {location.pickupInstruction}
            </div>
          </div>
          <div>
            <div className="col-xs">
              <Action
                onClick={e => {
                  e.stopPropagation()
                  goToLocation(location.deliveryLocationId)
                }}
                style={{ minHeight: '18px' }}
              >
                Select this kiosk &#8594;
              </Action>
            </div>
          </div>
        </div>
      )
    })}
  </div>
)

const SelectLocation = ({
  address,
  clearSearch,
  goToLocation,
  lat,
  lng,
  locations = [],
  search,
  showError,
  submitting,
  updateAddress,
}) => {
  const [isOpenId, setIsOpenId] = useState()
  const onToggleOpen = id => {
    if (id === isOpenId) {
      setIsOpenId(undefined)
    } else {
      setIsOpenId(id)
    }
  }
  return (
    <div className="row center-xs">
      <div className="col-xs-12">
        <div style={{ marginBottom: '16px ' }}>
          <h1 className="title" style={{ marginBottom: '16px ' }}>
            {search ? (
              <>
                {locations.length
                  ? `There are ${locations.length} kiosks near ${address}`
                  : 'Search for your kiosk'}
              </>
            ) : (
              `There are ${locations.length} kiosks near ${address}`
            )}
          </h1>
          {/* If no search function is passed in, assume it's just a kiosk picker */}
          {search && (
            <LocationSearchBox
              address={address}
              redirectOverride={true}
              search={search}
              showError={showError}
              submitting={submitting}
              updateAddress={updateAddress}
            />
          )}
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <GoogleMap
              goToLocation={goToLocation}
              isOpenId={isOpenId}
              lat={lat}
              lng={lng}
              locations={locations || []}
              onToggleOpen={onToggleOpen}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            {!address && <div>Search for an address to get started.</div>}
            {locations && locations.length === 0 && (
              <div>
                Sorry! There aren&apos;t any Foodsby pick-up locations with that
                address.
              </div>
            )}
            {locations && locations.length > 0 && (
              <LocationsList
                clearSearch={clearSearch}
                goToLocation={goToLocation}
                isOpenId={isOpenId}
                locations={locations}
                onToggleOpen={onToggleOpen}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export const RequestFoodsbyLink = () => (
  <div className="row center-xs">
    <div className="col-xs-12">
      <div style={{ marginTop: '16px' }}>
        Can&apos;t find Foodsby at your address?{' '}
        <Link to={noLocationRoute.path}>Request Foodsby</Link>.
      </div>
    </div>
  </div>
)

export default SelectLocation
